import { render, staticRenderFns } from "./StacksView.vue?vue&type=template&id=4ca34005&"
import script from "./StacksView.vue?vue&type=script&lang=js&"
export * from "./StacksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports